module.exports = ".contentCargaMasiva {\n  background-color: white;\n  min-height: 500px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/invoices-em-massive/invoicesem-massive.component.scss
// module id = ./src/app/pages/invoices-em-massive/invoicesem-massive.component.scss
// module chunks = main